export interface Remuneration {
    typeTransaction?: 'command' | 'lead';
    productType: ProductTypeEnum;
    mode: ModeEnum;
    percentage?: number; // Nullable (en fonction du mode)
    fixedAmount?: number; // Nullable (en fonction du mode)
    unit?: UnitEnum;
    startDate?: Date;
    endDate?: Date;
    provider: string;
    paymentMethod?: string;
    defaultRemuneration: boolean;
    flightDepartureCities?: string[];
    flightDepartureAirports?: string[];
    flightDepartureCountries?: string[];
    flightArrivalCities?: string[];
    flightArrivalAirports?: string[];
    flightArrivalCountries?: string[];
    flightMarketingCarriers?: string[];
}

export enum ProductTypeEnum {
    FLIGHT = 'flight',
    PARKING = 'parking',
    HOTEL = 'hotel',
    CAR = 'car'
}


export enum UnitEnum {
    FOLDER = 'FOLDER',
    PASSENGER = 'PASSENGER',
}

export enum ModeEnum {
    PERCENTAGE = 'PERCENTAGE',
    FIXED = 'FIXED',
}
